/** @jsx h */

// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import { PropTypes } from 'preact-compat';

export default class SupportedBrowserProvider extends Component {
  getChildContext() {
    const { isSupportedBrowser, isSupportedOS } = this.props;
    return { isSupportedBrowser, isSupportedOS };
  }

  render() {
    const { children } = this.props;
    return children[0];
  }
}

SupportedBrowserProvider.childContextTypes = {
  isSupportedBrowser: PropTypes.bool.isRequired,
  isSupportedOS: PropTypes.bool.isRequired,
};

SupportedBrowserProvider.propTypes = {
  isSupportedBrowser: PropTypes.bool.isRequired,
  isSupportedOS: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./components/global/supported-browser/index.js